import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import React from "react";
import { languages } from "../../constants/languages";

var QRCode = require("qrcode.react");

export default class QRCodeDialog extends React.Component {
  download = () => {
    const canvas = document.querySelector(".HpQrcode > canvas");
    this.downloadRef.href = canvas.toDataURL();
    this.downloadRef.download = "qr-code.png";
  };

  getTournamentUrl = () => {
    if (!this.props.tournament.liveLink) {
      return "";
    }

    const baseUrl =
      this.props.tournament.isPSD || this.props.tournament.crqpsd
        ? "https://tournify.prosoccerdata.com"
        : `https://tournifyapp.com/live`;

    return `${baseUrl}/${this.props.tournament.liveLink}`;
  };

  render() {
    const url = this.getTournamentUrl();

    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
        <form>
          <DialogContent style={{ width: 400, maxWidth: "97%", paddingTop: 0 }}>
            <div className="HpQrcode">
              <QRCode value={url} size={256} />
            </div>
            <div>
              <a
                href="/"
                style={{ textDecoration: "none" }}
                onClick={this.download}
                ref={(ref) => (this.downloadRef = ref)}
              >
                <Button
                  size="small"
                  variant="outlined"
                  color="default"
                  style={{ marginTop: 10 }}
                >
                  {languages.general.downloadQR}
                </Button>
              </a>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.close}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
